import { CompanyTypeCtrl }               from './dashboard.company-type';
import { Dashboard }                     from './dashboard.service';
import { DashboardCtrl }                 from './dashboard';
import { DashboardJobsCtrl }             from './dashboard.jobs';
import { DashboardStates }               from './dashboard.states.ajs';
import { DashboardTiremetrixCtrl }       from './dashboard.tiremetrix';
import { DashboardTransactionsCtrl }     from './dashboard.transactions';
import { GoogleCharts }                  from './dashboard.google-charts';
import { DashboardWorkingMechanicsCtrl } from './dashboard.working-mechanics';

angular.module('workshop.dashboard', [])
.controller('CompanyTypeCtrl',               CompanyTypeCtrl)
.controller('DashboardCtrl',                 DashboardCtrl)
.controller('DashboardJobsCtrl',             DashboardJobsCtrl)
.controller('DashboardTiremetrixCtrl',       DashboardTiremetrixCtrl)
.controller('DashboardTransactionsCtrl',     DashboardTransactionsCtrl)
.controller('DashboardWorkingMechanicsCtrl', DashboardWorkingMechanicsCtrl)

.factory('Dashboard',    Dashboard)
.factory('GoogleCharts', GoogleCharts)

.config(DashboardStates);